import { useApiFormAuthProvider } from '../../../../api-new/state/auth'
import { notePendingSignIn, ssoMethod } from '../../../../shared/recent-accounts/sign-in-memory'

// An absolute URL with its query built by URLSearchParams: every value is
// encoded (a "+" in an email, "=" in a base64 redirect), and a URL carried
// inside another URL's query can't break it apart. Empty values are left out.
export const withQuery = (base, params) => {
  const url = new URL(base)

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      url.searchParams.set(key, value)
    }
  })

  return url.toString()
}

// The URLs the auth service is handed when a sign-in with a connection
// starts. Where to go after signing in (redirect, redirect-doc) rides on
// the sign-in URL, which /open/auth reads; the cancel and error pages get it
// too, with the email, so "Back to sign in" and "Sign in with your password"
// keep the person's place.
export const providerSigninURL = ({ site, api, providerLink, token, email, redirect, redirectDoc }) => {
  const carry = { redirect, 'redirect-doc': redirectDoc }

  return withQuery(`${api}/api/v1/auth-provider/${encodeURIComponent(providerLink.identifier)}`, {
    token,
    'redirect-signin-url': withQuery(`${site}/open/auth`, carry),
    'redirect-cancel-url': withQuery(`${site}/auth/email`, { ...carry, email }),
    'redirect-error-url': withQuery(`${site}/auth/error`, { ...carry, email }),
    email
  })
}

export const useProviderSignin = () => {
  const apiFormAuthProvider = useApiFormAuthProvider()

  // inviteKey: a sign-in started from an invite page ("Sign in with your
  // organization"). It is POSTed with the passive token -- the auth service
  // keeps only its hash -- and never put in a URL.
  return async (providerLink, email, redirect, redirectDoc, inviteKey) => {
    let authPassave = inviteKey ? await apiFormAuthProvider.post({ inviteKey }) : await apiFormAuthProvider.post()

    // No prompt after a sign-out, deliberately: like Slack and Zoom, a
    // single signed-in account passes straight through. When an identity
    // provider must ask for credentials again is the customer's policy
    // (Entra Conditional Access sign-in frequency), not ours. The account
    // chooser appears on its own whenever several accounts are signed in.

    // Recent accounts: /open/auth remembers this connection as how the
    // account last signed in (sign-in-memory.js; never the token).
    notePendingSignIn(ssoMethod(providerLink))

    window.location.replace(providerSigninURL({
      site: process.env.REACT_APP_SITE,
      api: process.env.REACT_APP_API_AUTH,
      providerLink,
      token: authPassave.token,
      email,
      redirect,
      redirectDoc
    }))
  }
}
